(function () {
	'use strict';
	$(document).ready(function () {
		function getProjects(filterObject) {
			const nonce = fhGetConfig('nonce');

			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				method: 'post',
				timeout: 10000,
				data: {
					action: 'get_projects',
					service: filterObject['service'],
					building_type: filterObject['buildingType'],
					location: filterObject['location'],
					pager_page: filterObject['page'],
					nonce: nonce,
				},
				success: function (data) {
					$('#projects-list').empty().append(data);
				},
				error: function () {
					$('.projects-ajax-info .ajax-error').slideDown();
				},
				beforeSend: function () {
					$('.projects-ajax-info .ajax-error').slideUp();
					$('.projects-ajax-info .ajax-loading').slideDown();
					$('#projects-list').addClass('disabled');
				},
				complete: function () {
					$('.projects-ajax-info .ajax-loading').slideUp();
					$('#projects-list').removeClass('disabled');
				},
			});
		}

		$('#filter-form-search').on('click', function () {

			if (!$('#map').length) {
				$("html, body").animate({
					scrollTop: $('#projects-list').offset().top - 24
				}, 1000);
			}

			let locationFinal = null;

			const service = $('select[name="projects-service"]').val();
			const buildingType = $('select[name="projects-building-type"]').val();
			locationFinal = $('select[name="projects-location"]').val();

			if ( ($('#projects-voivodeship').length > 0) && $('select[name="projects-voivodeship"]').val() !== '') {
				locationFinal = $('select[name="projects-voivodeship"]').val();
			}

			if ( ($('#projects-city').length > 0) && $('select[name="projects-city"]').val() !== '') {
				locationFinal = $('select[name="projects-city"]').val();
			}

			const page = parseInt($('.projects-list-pager .page-numbers.current').text());
			const filterObject = {
				'service': service,
				'buildingType': buildingType,
				'location': locationFinal,
				'page': page,
			};
			getProjects(filterObject);
		});

		$('#filter-form-clear').on('click', function () {

			if (!$('#map').length) {
				$("html, body").animate({
					scrollTop: $('#projects-list').offset().top - 24
				}, 1000);
			}

			$('#filter-form-group-voivodeships').remove();
			$('#filter-form-group-cities').remove();

			$('#projects-filter-form').trigger('reset');
			const filterObject = {
				'service': null,
				'buildingType': null,
				'location': null,
				'page': 0,
			};
			getProjects(filterObject);
		});

		$(document).on('click', '.projects-list-pager .page-numbers', function (e) {
			e.preventDefault();

			$("html, body").animate({
				scrollTop: $('#projects-list').offset().top - 24
			}, 1000);

			let locationFinal = null;

			const service = $('select[name="projects-service"]').val();
			const buildingType = $('select[name="projects-building-type"]').val();
			locationFinal = $('select[name="projects-location"]').val();

			if ( ($('#projects-voivodeship').length > 0) && $('select[name="projects-voivodeship"]').val() !== '') {
				locationFinal = $('select[name="projects-voivodeship"]').val();
			}

			if ( ($('#projects-city').length > 0) && $('select[name="projects-city"]').val() !== '') {
				locationFinal = $('select[name="projects-city"]').val();
			}

			const page = parseInt($(this).text());
			const filterObject = {
				'service': service,
				'buildingType': buildingType,
				'location': locationFinal,
				'page': page,
			};
			getProjects(filterObject);
		});

	});
}(jQuery));
